import {Feature} from 'acng/core/model/feature.js';

const name = 'livecam';
export default name;
export const livecamFeature = new Feature(name);

